
// 计算到期日
function dateFormat(validDays, fstr, utc) {
  utc = utc ? 'getUTC' : 'get';
  const timestamp = new Date().getTime() + validDays;
  const date = new Date(timestamp);
  return fstr.replace(/\%[YmdHMS]/g, function (m) {
    // alert(m);
    switch (m) {
      case '%Y':
        return date[utc + 'FullYear'](); // no leading zeros required
      case '%m':
        m = 1 + date[utc + 'Month']();
        break;
      case '%d':
        m = date[utc + 'Date']();
        break;
      case '%H':
        m = date[utc + 'Hours']();
        break;
      case '%M':
        m = date[utc + 'Minutes']();
        break;
      case '%S':
        m = date[utc + 'Seconds']();
        break;
      default:
        return m.slice(1); // unknown code, remove %
    }
    // alert(m);
    // add leading zero if required
    return ('0' + m).slice(-2);
  });
}
// 计算百分比
function memoryPer(size1, size2) {
  if (typeof size1 != 'number' || typeof size2 != 'number') {
    size1 = parseInt(size1);
    size2 = parseInt(size2);
  }
  let result = '0%';
  if (size2 !== 0) {
    const temp = (1 - size1 / size2) * 100;
    if (temp > 0) {
      result = Math.floor((1 - size1 / size2) * 100) + '%';
    }
  }
  return result;
}
// 计算空间
function memory(size) {
  const Gb = 1024 * 1024 * 1024;
  const Mb = 1024 * 1024;
  if (typeof size != 'number') {
    size = parseInt(size);
  }
  return size > Gb
    ? (size / Gb).toFixed(1) + 'G'
    : (size / Mb).toFixed(0) + 'M';
}


// 获取QQ/微信登陆态
function getLoginKey(type, openid = '') {
  if (type == 'qq') {
    return gj.getQQLoginKey(openid);// openid
  } else {
    return gj.getWXLoginKey(openid);// 微信openid
  }
}

function urlHelper(url) {
	const __query = function (str = '') {
		let params = str.split('&');
		let result = {};
		for (let i = 0, l = params.length; i < l; i++) {
			let one = params[i].split('=');
			result[one[0]] = one.length > 1 ? decodeURIComponent(one[1]) : '';
		}
		return result;
	}
	let urlAndHash = url.split('#');
	let urlNotHash = urlAndHash[0];
	let urlAndQuery = urlNotHash.split('?');
  let queryString = urlAndQuery[1];

  if(urlAndHash[1]){
    let queryString2 = urlAndHash[1].split('?')[1];
    queryString = queryString +'&'+ queryString2;
  }
	return __query(queryString);
}
export default {
  dateFormat,
  memoryPer,
  memory,
  getLoginKey,
  urlHelper
}
